
var quoteModule = angular.module('quote', ['common', 'finance']);

quoteModule.factory('quoteCreationEvents', function () {
    return {
        vehicleDataChanged : 'TLC-VEHICLE-CHOICE-CHANGED',
        vehicleDataComplete : 'TLC-VEHICLE-DATA-COMPLETE',
        vechicleDataChangedProceed: 'TLC-VEHICLE-DATA-CHANGED-PROCEED',
        vehicleDataRestore: 'TLC-VEHICLE-DATA-RESTORE',
        mastervehicleDataComplete : 'TLC-VEHICLE-DATA-COMPLETE-MASTER',
        vehicleReadyForProduct : 'TLC-VEHICLE-READY-FOR-PRODUCT',
        productChoiceChanged : 'TLC-PRODUCT-CHOICE-CHANGED',
        productDataReceived : 'TLC-PRODUCT-DATA-RECEIVED',
        productDataComplete : 'TLC-PRODUCT-DATA-COMPLETE',
        dealDataComplete : 'TLC-DEAL-DATA-COMPLETE',
        dealDataChanged : 'TLC-DEAL-DATA-CHANGED',
        rateTermsComplete : 'TLC-RATE-TERMS-COMPLETE',
        rateTermChosen : 'TLC-RATE-TERMS-CHOSEN',
        customerDataChange : 'TLC-CUSTOMER-DATA-CHANGED',
        customerDataComplete : 'TLC-CUSTOMER-DATA-COMPLETE',
        providerDataChanged : 'TLC-PROVIDER-DATA-CHANGED',
        providerDataComplete : 'TLC-PROVIDER-DATA-COMPLETE',
        vehicleDataError : 'TLC-VEHICLE-DATA-ERROR',
        productDataError : 'TLC-PRODUCT-DATA-ERROR',
        rateTermDataError : 'TLC-RATE-TERMS-DATA-ERROR',
        startNewProductQuote : 'TLC-START-NEW-PRODUCT-QUOTE',
        saveRatesToQuotes : 'TLC-SAVE-RATES-TO-QUOTE',
        sendQuotesToIntegrationApp : 'TLC-SEND-QUOTES-TO-APP',
        refreshQuoteQueue : 'TLC-REFRESH-QUOTE-QUEUE',
        attemptQuoteSave : 'TLC-ATTEMPT-QUOTE-SAVE',
        removeCurrentQuotes : 'TLC-REMOVE-QUOTES',
        customerDataRetrieved : 'TLC-CUSTOMER-DATA-RETRIEVED',
        vehicleDataRetrieved : 'TLC-VEHICLE-DATA-RETRIEVED',
        dealDataRetrieved : 'TLC-DEAL-DATA-RETRIEVED',
        loadingExistingQuote : 'TLC-LOADING-EXISTING-QUOTE',
        scenarioChanged : 'TLC-SCENARIO-CHANGED',
        quoteRemovedFromScenario : 'TLC-SCENARIO-QUOTE-REMOVED',
        rateChosen : 'TLC-RATE-CHOSEN',
        saveRatesToCompleted : 'TLC-SAVE-RATES-TO-QUOTE-COMPLETE',
        productTypeChosen: 'TLC-RATE-PRODUCT-TYPE-CHOSEN',
        productTypeChosenEmit: 'TLC-RATE-PRODUCT-TYPE-CHOSEN-EMIT',
        invalidProductTypeChosenContract: 'TLC-CONTRACT-PRODUCT-TYPE-INVALID',
        initQuoteContractValues: 'TLC-INIT-QUOTE-CONTRACT-VALUES',
        RERATE_PRODUCT: "TLC-RERATE-PRODUCT",
        queueUpIntegration: "TLC-QUEUE-INTEGRATION",
        sendIntegration: "TLC-SEND-INTEGRATION",
        filteringProductRetrieved: "TLC-FILTERING-PRODUCT-RETRIEVED",
        filteringProductsSelected: "TLC-FILTERING-PRODUCTS-SELECTED",
        cleanRatesFromQueue: "TLC-CLEAN-RATES-FROM-QUEUE",
        unCheckForceLoading: "TLC-UNCHECK-FORCE-LOADING",
        showPrinterOnDiv: "TLC-SHOW-PRINTER",
        divSelectedToPrint: "TLC-PRINTER-TEXT"
    };
});

quoteModule.factory('quoteIntegrationConstants', function() {
    return {
        menuQuoteIntegrated : 'MENUPRO_INTEGRATED_QUOTE',
        searchIntegrated : 'SEARCH_INTEGRATED',
        newQuoteIntegrated : 'NEW_QUOTE_INTEGRATED',
        menuContractIntegrated : 'MENUPRO_INTEGRATED_CONTRACT'
    };
});

quoteModule.constant('productSettingsDialogConstants',
    {
        // names of the views
        profitType: "ProfitType",
        additionalMarkup: "AdditionalMarkup",
        overRemit: "OverRemit",
        defaults: "Defaults"
    }
);

quoteModule.constant('vehicleTypeConstants',
    {
        // names of the views
        rv: "RV",
        rvAndAuto: "RVAUTO",
        auto: "AUTO"
    }
);


